import {
  applyMiddleware,
  combineReducers,
  createStore,
} from 'redux';
import thunk from 'redux-thunk';
import {logger} from 'src/pages/category/store/enhancers/logger';
import {topics} from 'src/pages/category/store/enhancers/topics';
import {channelTracking} from 'src/pages/category/store/enhancers/channelTracking';
import {selectedTopics} from 'src/pages/category/store/reducers/topics';
import {auth} from 'src/shared/auth/reducers';
import {config} from 'src/shared/config/reducers';
import {content} from 'src/shared/content/reducers';
import {cookie} from 'src/shared/cookie/reducers';
import {datacast} from 'src/shared/datacast/reducers';
import {dropBury} from 'src/shared/dropBury/reducers';
import {events} from 'src/shared/events/middleware';
import {extendedProfile} from 'src/shared/extendedProfile/reducers';
import {guidedSearch} from 'src/shared/guidedSearch/reducers';
import {outages} from 'src/shared/outages/reducers';
import {params} from 'src/shared/params/reducers';
import {
  personalization,
  personalizationHistory,
  supportlets,
} from 'src/shared/personalization/reducers';
import {resourceStatus} from 'src/shared/resourceStatus/reducers';
import {user} from 'src/shared/user/reducers';
import {compose} from 'src/shared/utils/compose';

export const store = createStore(
  combineReducers({
    auth,
    config,
    content,
    cookie,
    datacast,
    dropBury,
    extendedProfile,
    guidedSearch,
    outages,
    params,
    personalization,
    personalizationHistory,
    resourceStatus,
    selectedTopics,
    supportlets,
    user,
  }),
  compose(
    applyMiddleware(
      thunk,
      logger,
      topics,
      channelTracking,
      events
    )
  )
);
